import {ENVIRONMENT_DEN_ILP, ENVIRONMENT_DEVARANA, ENVIRONMENT_RIDDERRODE, ENVIRONMENT_SWEETLAKE} from "./AppConstants.js";
import DateTimeUtil from "./utils/DateTimeUtil.js";
import AppConfigDenIlp from "./AppConfigDenIlp.js";
import AppConfigRidderrode from "./AppConfigRidderrode.js";
import AppConfigDevarana from "./AppConfigDevarana.js";
import AppConfigSweetlake from "./AppConfigSweetlake.js";
import {progress} from "./data/progress/feature.progress.svelte.js";

// import DateTimeUtil from "../utils/DateTimeUtil";

class AppConfig {
  static aHostToEnvMap = {
    "saunadevarana.nl": ENVIRONMENT_DEVARANA,
    "www.saunadevarana.nl": ENVIRONMENT_DEVARANA,
    "saunadenilp.nl": ENVIRONMENT_DEN_ILP,
    "www.saunadenilp.nl": ENVIRONMENT_DEN_ILP,
    "denilp2025.hamakaserver.nl": ENVIRONMENT_DEN_ILP,
    "ridderrode2025.hamakaserver.nl": ENVIRONMENT_RIDDERRODE,
    "saunaridderrode.nl": ENVIRONMENT_RIDDERRODE,
    "www.saunaridderrode.nl": ENVIRONMENT_RIDDERRODE,
    "sweetlakewellness.nl": ENVIRONMENT_SWEETLAKE,
    "www.sweetlakewellness.nl": ENVIRONMENT_SWEETLAKE,
    "lwr-accept.hamakaserver.nl": ENVIRONMENT_SWEETLAKE,
    "www.lwr-accept.hamakaserver.nl": ENVIRONMENT_SWEETLAKE,
    "localhost": ENVIRONMENT_SWEETLAKE
  };

  // static aEnvToMap = {
  //   "saunadevarana.nl": ENVIRONMENT_DEVARANA,
  //   "www.saunadevarana.nl": ENVIRONMENT_DEVARANA,
  //   "saunadenilp.nl": ENVIRONMENT_DEN_ILP,
  //   "www.saunadenilp.nl": ENVIRONMENT_DEN_ILP,
  //   "denilp2025.hamakaserver.nl": ENVIRONMENT_DEN_ILP,
  //   "saunaridderrode.nl": ENVIRONMENT_RIDDERRODE,
  //   "www.saunaridderrode.nl": ENVIRONMENT_RIDDERRODE,
  //   "localhost": ENVIRONMENT_RIDDERRODE
  // };

  static bDebugFlow = false;

  static bDebugUseFakeAjaxCalls = false;
  static bDebugUseFakeAjaxCallsOnLocalhost = true;

  // static iDebugShowOnly1Deal = 10; // 0 is uit
  static iDebugShowOnly1Deal = 0; // 0 is uit
  static bDebugUseLocalRootURL = true;
  static bShowFormDebugOnLocal = false;
  static bLogCalculateTotalsStepsToConsole = false;
  static bLocalAutoMountDevTools = false;

  // Wat voor sandbox wil je lokaal bovenaan zien (normaal gesproken allemaal uit)
  static bLocalSandboxShowTextDemo = false;
  static bLocalSandboxShowButtonsLoadersIcons = false;
  static bLocalSandboxShowCards = false;
  static bLocalSandboxShowProductsAndPackageDeals = false;

  // Wil je lokaal in stap 10 een formulier bovenaan zetten?
  static bLocalTestFormInStep10Booking = false;
  static bLocalTestFormInStep10Payment = false;
  static bLocalTestFormInStep10Login = false;

  static iLocalDirectlyGoToStepAfterStart = 10;

  static bIsCadeaubonVoucherRedeemEnabled = true;
  static bIsBadenkaartDagEnabled = true;
  static bIsBadenkaartShortEnabled = true;

  static bIsAccountLoginEnabled = true;
  static bIsAccountCreationEnabled = false;

  static bIsDinnerTimeSelectionEnabled = true;

  static bIsCorrectLocationLoaded = false;

  // DEZE CONFIGURATIE IS DEVARANA - DAT IS DE DEFAULT - ZIE HIERONDER VOOR OVERRIDES VOOR OVERIGE LOCATIES
  static sCurrentConfigDebugLabel = ENVIRONMENT_DEVARANA;

  static iNrOfActieArrangementCatThatShouldBeHidden = 9;
  static iNoDinnerUntilAfterThisTime = 1700;

  // ENTREES
  static aNonActieEntreeExternalIDs = [1, 3, 45, 46, 135, 332, 854, 934]; // main entrees -  moet overeen moet komen met corresponderende PHP array $MAIN_NIET_ACTIE_ENTREES

  static iDefaultEntreeID = 1; // als er geen product in de order staat wordt deze 'hele dag toegang' entree als default toegevoegd; bij TB is dat 1
  static iDefaultEntreeBadenkaartID = 332; // als er geen product in de order staat wordt deze 'hele dag toegang' entree als default toegevoegd; bij TB is dat 1
  static aEntreeOchtendExternalIDs = []; // moeten ook gewoon in aNonActieEntreeExternalIDs staan -  soesterberg had aanvankelijk geen ochtendentree
  static iDefaultEntreeOchtendClosingTime = 1400; // bijv 1400 laatst mogelijke vertrektijd; vanaf 1401 en later zal dan geblokkeerd worden
  static aEntreeAvondExternalIDs = [5]; // moeten ook gewoon in aNonActieEntreeExternalIDs staan
  static iEntree2uurExternalID = 3; // moeten ook gewoon in aNonActieEntreeExternalIDs staan
  static iEntree2uurBadenkaartExternalID = 332; // moeten ook gewoon in aNonActieEntreeExternalIDs staan
  static aEntreeDagIDEALKortingExternalID = 854; //ID welke geboekt moet worden als mensen met iDEAL betalen bij een dagentree

  // RECOMMENDED
  static aRecommendedPackageDealIDs = [34, 37];

  // ARRANGEMENT
  static iFallbackPackageDealWithoutTreatmentsID = 38;

  // HORECA
  static iDinnerProductID = 77;

  //GIFTCARDS
  static iMaxRedeemableGiftcards = 4;

  //BADENKAARTEN
  static iMaxRedeemableBadenkaarts = 4;

  // SPECIALE DAGEN
  // De eerste mogelijkheid om dagen in de kalender een extra kleurtje te geven
  static aDatesWithAlternativeTimes = [];

  // De tweeden mogelijkheid om dagen in de kalender een extra kleurtje te geven (nog niet gebruikt dus kleur is nog rood - zie onderaan shared-webshop.scss)
  static aDatesWithHighlightColor = [
    // '25-03-2025'
  ];

  static sTextTimeNormalEntreeFirstArrival = '12:00';
  static sTextTimeNormalEntreeLastDeparture = '22:00';
  static sTextTimeAvondEntreeFirstArrival = '17:00';

  static aTimeConfig = {
    day0: { // ZONDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    day1: { // MAANDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    day2: { // DINSDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    day3: { // WOENSDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    day4: { // DONDERDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    day5: { // VRIJDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    day6: { // ZATERDAG
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    daySpecial1: { // Kerstavond (24 DEC)
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1800, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    },
    daySpecial2: { // Oudejaarsavond (31 DEC)
      iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
      iDefaultOpeningTimeNonSauna: 1100,  // niet meer in gebruik
      iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

      iDefaultLastEntryTime: 1700, // tijd waarop standaard de deuren sluiten
      iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

      // NAAR BUITEN GAAN
      iDefaultClosingTimeNonSauna: 1800,  // niet meer in gebruik
      iDefaultClosingTime: 1800 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
    }
  };

  // Het idee achter oDateIfNotMondayInSeptember is dat er in september geen feestdagen oid zijn dus
  // dat een maandag in september de beste kans is op een standaard doordeweekse dag als fallback voor
  // het opvragen van defaults als er nog geen aankomstdatum is.
  // Let op: als je hier voor 1 sauna specifiek een configuratie op wil zetten, check dan sEnvironmentID (zie hieronder)
  // en let er op dat je die daySpecialX config toevoegt in de de AppConfig van die sauna
  static getTimeConfigForDay = (oDateIfNotMondayInSeptember = false) => {
    const sEnvironmentID = progress.sEnvironmentID;

    let oDate = false;

    if ( oDateIfNotMondayInSeptember !== false )
    {
      oDate = oDateIfNotMondayInSeptember;
    }
    else
    {
      oDate = DateTimeUtil.getMondayInSeptember();
    }

    const iDayOfWeek = oDate.getDay();
    const iDay = oDate.getDate();
    const iMonth = oDate.getMonth() + 1;
    const iYear = oDate.getFullYear();

    let aTimeConfig = AppConfig.aTimeConfig['day' + iDayOfWeek];

    // Sweetlake: sauna gaat om 9:00 open op zomerse weekenddagen (vanaf 27 juni 2026) en
    // vanaf 1 september 2026 op alle 7 dagen. Staat bewust boven de feestdag-specials hieronder,
    // zodat Kerstavond/Oudejaarsavond hun eigen openingstijd houden (die overschrijven dit).
    if ( sEnvironmentID === ENVIRONMENT_SWEETLAKE )
    {
      const bIsWeekend      = ( iDayOfWeek === 0 || iDayOfWeek === 6 );
      const iDateNum        = iYear * 10000 + iMonth * 100 + iDay; // YYYYMMDD, makkelijk te vergelijken
      const bSummerWeekend  = bIsWeekend && iDateNum >= 20260627;  // weekenden vanaf 27 juni
      const bFromSeptember1 = iDateNum >= 20260901;                // daarna alle 7 dagen

      if ( bSummerWeekend || bFromSeptember1 )
      {
        aTimeConfig = { ...aTimeConfig, iDefaultOpeningTimeSauna: 900 };
      }
    }

    if ( iYear === 2024 && iMonth === 12 && iDay === 24 && AppConfig.aTimeConfig['daySpecial1'] )
    {
      aTimeConfig = AppConfig.aTimeConfig['daySpecial1'];
    }

    if ( iMonth === 12 && iDay === 31 && AppConfig.aTimeConfig['daySpecial2'] )
    {
      aTimeConfig = AppConfig.aTimeConfig['daySpecial2'];
    }

    return aTimeConfig;
  };

  static getIDefaultOpeningTime = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);

    if ( aTimeConfig.iDefaultOpeningTimeSauna < aTimeConfig.iDefaultClosingTimeNonSauna ) return aTimeConfig.iDefaultOpeningTimeSauna;
    return aTimeConfig.iDefaultClosingTimeNonSauna;
  };

  static getIDefaultOpeningTimeSauna = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen.
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iDefaultOpeningTimeSauna;
  };

  static getIDefaultOpeningTimeNonSauna = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iDefaultOpeningTimeNonSauna;
  };

  static getIDefaultLastEntryTime = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iDefaultLastEntryTime;
  };

  static getIDefaultLastEntryTimeNonSauna = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iDefaultLastEntryTimeNonSauna;
  };

  static getIFirstEntryTimeEveningEntry = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iFirstEntryTimeEveningEntry;
  };

  static getIDefaultClosingTime = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iDefaultClosingTime;
  };

  static getIDefaultClosingTimeNonSauna = (oDateIfNotMondayInSeptember = false) => {
    if ( AppConfig.bIsCorrectLocationLoaded === false ) return false; // is nodig om meteen duidelijk te hebben dat hier te vroeg dingen worden geladen
    const aTimeConfig = AppConfig.getTimeConfigForDay(oDateIfNotMondayInSeptember);
    return aTimeConfig.iDefaultClosingTimeNonSauna;
  };

  // voordat hoofdcomponent BookingApp wordt gemount worden hier de goede waardes in de variabelen hierboven geladen
  static loadConfig = (sConfigName = ENVIRONMENT_DEVARANA) => {
    if ( !sConfigName ) sConfigName = ENVIRONMENT_DEVARANA;

    switch ( sConfigName )
    {
      case ENVIRONMENT_DEVARANA:
        AppConfigDevarana.loadConfig();
        break;
      case ENVIRONMENT_DEN_ILP:
        AppConfigDenIlp.loadConfig()
        break;
      case ENVIRONMENT_RIDDERRODE:
        AppConfigRidderrode.loadConfig();
        break;
      case ENVIRONMENT_SWEETLAKE:
        AppConfigSweetlake.loadConfig();
        break;
    }

    if ( AppConfig.bDebugUseFakeAjaxCallsOnLocalhost === true )
    {
      const sHost = window.location.hostname;
      if ( sHost === 'localhost' )
      {
        AppConfig.bDebugUseFakeAjaxCalls = true;
      }
    }

    AppConfig.bIsCorrectLocationLoaded = true;
  };


}

export default AppConfig;